import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { grantGA4Consent, denyGA4Consent, getConsentStatus } from "@/lib/ga4";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsentStatus() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => { grantGA4Consent(); setVisible(false); };
  const decline = () => { denyGA4Consent(); setVisible(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-5 pointer-events-none"
    >
      <div className="mx-auto max-w-2xl pointer-events-auto bg-slate-900 border border-slate-700 rounded-xl shadow-2xl px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-slate-300 flex-1 leading-relaxed">
          We use analytics to improve Stratakey. Accept or decline.{" "}
          <a
            href="/privacy"
            className="text-primary hover:text-primary/80 underline underline-offset-2 whitespace-nowrap"
          >
            Privacy Policy
          </a>
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            size="sm"
            variant="outline"
            className="border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white"
            onClick={decline}
          >
            Decline
          </Button>
          <Button
            size="sm"
            className="bg-primary hover:bg-primary/90 text-white"
            onClick={accept}
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
